/**
 * Import all module depenencies here.
 * Add commonly used modules to externals.
 */
import core from '../../app.core.module.js';
import termscondConfig from './termscond.config.js';
import termscondRoute from './termscond.route.js';
import termscondController from './termscond.controller.js';
import termscondService from './termscond.service.js';
import termscondDataService from './termscond.data.service.js';
import resize from './resize.js';
/**
 * This is the termscond module. It it the entry point for this website.
 * Only declare the module's dependencies in this file.
 * @namespace termscond Module
 */
angular.module('termscond', [
  // Shared modules.
  core
])
// Register config.
.config(termscondConfig)
// Register route.
.config(termscondRoute)
// Register directive.
.directive('resize', ['$window', resize])
// Register controller.
.controller('termscondController', termscondController)
// Register service.
.factory('termscondService', termscondService)
// Register data service.
.factory('termscondDataService', termscondDataService);

export default 'termscond';



// WEBPACK FOOTER //
// ./src/login/termscond/termscond.module.js